// removed by extract-text-webpack-plugin
module.exports = {"absolute":"_2n4jf95wjupzzq26stq5np7m2hz7uvgk5xtk8nva6e8fmt41xu3mwyvw6zajc7w85zda25beszdb3jpb424abac259x5s3fzm1c9qn2-CountingNumber-module-absolute"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CountingNumber.module.css
// module id = 177
// module chunks = 0